import { Form } from "antd";
import { useState } from "react";
import { Modal } from "../../../../../common/components/modal/modal";
import { RecruiterGoalsForm } from "../createGoalsButton/recruiterGoalsForm";

export const EditGoalsModal = ({
  open,
  loading,
  onFinish,
  availableClients,
  goal,
  closeModal,
  ...props
}) => {
  const [isDirty, setIsDirty] = useState(false);

  const [form] = Form.useForm();

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      title="Edit Recruiter Goals"
      className="modal-overflow-auto s2-theme-style"
      onOk={form.submit}
      okButtonProps={{ loading, disabled: !isDirty }}
      {...props}
    >
      <RecruiterGoalsForm
        form={form}
        onFinish={onFinish}
        clients={availableClients}
        disableClientSelection={true}
        defaultValues={goal}
        onDirtyChange={setIsDirty}
      />
    </Modal>
  );
};
